export var size10 = '10px';
export var size12 = '12px';
export var size13 = '13px';
export var size14 = '14px';
export var size16 = '16px';
export var size18 = '18px';
export var size20 = '20px';
export var size24 = '24px';
export var size28 = '28px';
export var size32 = '32px';
export var size42 = '42px';
export var size68 = '68px';
